<div class="flex flex-col gap-4 mb-4">
  <p-button (onClick)="downloadCsv()">Download CSV</p-button>
  <div class="flex gap-2">
    <input pInputText placeholder="email" [(ngModel)]="email"/>
    <p-button [loading]="emailSearchLoading()" (onClick)="onEmailSearchClick()">Search</p-button>
  </div>
  <div class="flex gap-2">
    <input pInputText placeholder="userId" [(ngModel)]="userId"/>
    <p-button [loading]="userIdSearchLoading()" (onClick)="onUserIdSearchClick()">Search</p-button>
  </div>
  <div class="flex gap-2">
    <p-select [options]="options" [(ngModel)]="statusOption"></p-select>
    <p-button [loading]="statusSearchLoading()" (onClick)="onStatusSearchClick()">Search</p-button>
  </div>
</div>
<!--<p-button-group>-->
<!--  <p-button-->
<!--    (onClick)="getNycAuth()"-->
<!--    label="Get NYC login"-->
<!--    icon="pi pi-lock"-->
<!--    [disabled]="!(selectedUser() && selectedUser()?.nycProfileStatus !== 'not-created')"/>-->

<!--  <p-button-->
<!--    (onClick)="unlockEmailTwo()"-->
<!--    label="Unlock email 2 state"-->
<!--    icon="pi pi-lock"-->
<!--    [disabled]="!(selectedUser() && selectedUser()?.nycProfileStatus === 'waiting-on-email2-verification')"/>-->
<!--  @if (selectedUser() && selectedUser()?.status === 'active') {-->
<!--    <p-button-->
<!--      (onClick)="onIgnoreToggle()"-->
<!--      label="Toggle ignore"-->
<!--      icon="pi pi-pencil"/>-->
<!--  }-->

<!--  <p-button (onClick)="getRegisterList()" label="Get register list"-->
<!--    icon="pi pi-download">-->
<!--  </p-button>-->
<!--  <p-button-->
<!--    (onClick)="resyncApplications()"-->
<!--    label="Resync applications"-->
<!--    icon="pi pi-refresh"-->
<!--    [disabled]="!(selectedUser() && selectedUser()?.nycProfileStatus === 'complete')"/>-->
<!--  <p-button (onClick)="getFailedChildren()" label="Get failed with children"-->
<!--            icon="pi pi-download">-->
<!--  </p-button>-->
<!--  <p-button-->
<!--    (onClick)="onDeleteClick()"-->
<!--    label="Delete"-->
<!--    icon="pi pi-trash"-->
<!--    [disabled]="!(selectedUser())"/>-->

<!--</p-button-group>-->
<p-table
  [value]="sortedUsers()" selectionMode="single" [selection]="selectedUser()"
         (selectionChange)="selectedUser.set($event)">
  <ng-template pTemplate="header">
    <tr>
      <th>Id</th>
      <th>Created at</th>
      <th>Name</th>
      <th>Email</th>
      <th>Payment</th>
      <th>Status</th>
      <th>NYC Profile</th>
      <th>NYC Sync</th>
      <th>Household Size</th>
      <th>Lottery Notifications</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user>
    <tr [pSelectableRow]="user" [routerLink]="['/users', user.id]">
      <td>{{ user.id }}</td>
      <td>{{ user.createdAt | date:'M/d/yy, h:mm a' }}</td>
      <td>{{ user.firstName }}</td>
      <td>{{ user.email }}</td>
      <td>
        <p-tag>{{ user.paymentStatus }}</p-tag>
      </td>
      <td>
        <p-tag>{{ user.status }}</p-tag>
      </td>
      <td>
        <p-tag>{{ user.nycProfileStatus }}</p-tag>
      </td>
      <td>
        @if (user.nycSyncStatus) {
          <p-tag>{{ user.nycSyncStatus }}</p-tag>
        }
      </td>
      <td>{{ user.householdSize }}</td>
      <td>{{ user.lotteryNotifications }}</td>
      <td>
        @if (user.ignore) {
          <p-tag severity="danger">IGNORED</p-tag>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
